export default function Footer() {
    return (
        <footer id="footer">
            <div className="container">
                <div className="footer">
                    <img style={{display:'inline'}} className="logo text-center" src="assets/logo2.png" alt="Footer logo" />
                </div>
            </div>
        </footer>
    )
}